import { FrontendApi, Configuration } from '@ory/client-fetch'
import { config } from '@/lib/helpers/config.helpers'

export interface OryApi extends FrontendApi {}

export const ory = new FrontendApi(
  new Configuration({
    basePath: config.oryApiUrl,
    credentials: 'include',
  }),
)
